import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { PublisherResource, publishersGetMe } from '~/generated';
import { AxiosError } from 'axios';
import { extractData } from '~/utils/query-utils';

export const usePublisherMe = (
  options: Omit<UseQueryOptions<PublisherResource, unknown>, 'queryKey'> = {}
) => {
  const query = useQuery({
    queryFn: () => extractData(publishersGetMe()),
    queryKey: ['publishers', 'me'],
    retry: false,
    ...options,
  });

  useEffect(() => {
    if (
      query.isError &&
      query.error instanceof AxiosError &&
      query.error.response?.status === 401
    ) {
      window.location.href = `/Identity/Account/Login`;
    }
  }, [query.isError, query.error]);

  return query;
};
